import { Offer } from 'common/contracts';
import { OfferType } from 'constants/enums';
import { timeUtils } from 'utils/scheduleUtils';
import {
  buildBaseInitialValues,
  buildEmblemBadgeInitialValues,
  buildOfferUiIdInitialValue,
  buildPriceFromCents,
  buildProgressBarInitialValues,
  buildSaleDiscountInitialValues,
  buildScheduleInitialValue,
  buildSectionTabInitialValues,
  buildSetAsFreeInitialValue
} from 'views/Offers/Offer.utils';

// --- Form initial values ---

interface IBuildPromotionFormInitialValuesParams {
  data: Partial<Offer>;
  edit: boolean;
  dup: boolean;
  defaultOfferDesignId: string;
  getOfferResult?: Partial<Offer>;
}

export const buildPromotionFormInitialValues = ({
  data,
  edit,
  dup,
  defaultOfferDesignId,
  getOfferResult
}: IBuildPromotionFormInitialValuesParams) => ({
  ...buildBaseInitialValues(data, edit, dup),
  setAsFree: buildSetAsFreeInitialValue(data, edit, dup),
  offerId: data.offerId,
  price: buildPriceFromCents(data.productsSequence?.[0]?.priceInUsdCents),
  playerAvailability:
    data.productsSequence?.[0]?.playerAvailability ?? undefined,
  type: OfferType.SPECIAL_OFFER,
  offerUiId: buildOfferUiIdInitialValue(
    data, edit, dup, defaultOfferDesignId, getOfferResult
  ),
  coolDownInHours: data.coolDownInHours || 0,
  schedule: buildScheduleInitialValue(data),
  startHour: timeUtils.getTimeFromCron(data?.schedule?.interval || '')
    ?.hourFromCron,
  active: data.active ?? true,
  quantity: '',
  backgroundImage: data?.offerUi?.backgroundImage || '',
  productsSequence: data.productsSequence || {},
  ...buildEmblemBadgeInitialValues(data),
  ...buildSaleDiscountInitialValues(data),
  priceBeforeDiscount: data?.priceDiscount?.priceBeforeDiscount
    ? data.priceDiscount.priceBeforeDiscount / 100
    : null,
  ...buildSectionTabInitialValues(data),
  ...buildProgressBarInitialValues(data)
});
